import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';


import { RouterModule } from '@angular/router';
import { appRoutes } from './app.routing';

 
 
import { AppComponent } from './index';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { ListComponent } from './list/list.component';
import { ServicesComponent } from './services/services.component';
import { NewsComponent } from './news/news.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { AboutComponent } from './about/about.component';
import { AdvertisementComponent } from './advertisement/advertisement.component';

import { TnsearchpanelComponent } from './components/tnsearchpanel/tnsearchpanel.component';
import { TnhomedescComponent } from './components/tnhomedesc/tnhomedesc.component';
import { TnadslistComponent } from './components/tnadslist/tnadslist.component';
import { TnadslistItemComponent } from './components/tnadslist-item/tnadslist-item.component';
import { TnfacebookwidgetComponent } from './components/tnfacebookwidget/tnfacebookwidget.component';
import { TnsiteheaderComponent, SiteLogo } from './components/tnsiteheader/tnsiteheader.component';
import { TnsitefooterComponent } from './components/tnsitefooter/tnsitefooter.component';
import { TnhomesliderComponent } from './components/tnhomeslider/tnhomeslider.component';
import { TnhomenewslistComponent } from './components/tnhomenewslist/tnhomenewslist.component';
import { TnnewslistComponent } from './components/tnnewslist/tnnewslist.component';
import { TnnewslistItemComponent } from './components/tnnewslist-item/tnnewslist-item.component';
import { TnsearchcodeComponent } from './components/tnsearchcode/tnsearchcode.component';
import { TnadslistadvComponent } from './components/tnadslistadv/tnadslistadv.component';
import { Tnrandomadv } from './components/tnrandomadv/randomadv.component';
import { TnadslistadvItemComponent } from './components/tnadslistadv-item/tnadslistadv-item.component';
import { DetailComponent } from './detail/detail.component';
import { NewsdetailComponent } from './newsdetail/newsdetail.component';

import { SiteConfigurationService } from './common/site-configuration.service';
import { TempConvertPipe } from './common/pipe-translate';

import { Meta } from './common/seo.service';
import { TnGoogleMap } from './components/tngooglemap/tngooglemap.component';

import { NgbdModalCustomclass } from './modals/Custom_Modal';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

export function initConfig(config: SiteConfigurationService)  {
  return () => config.load(); 
}
// export function initConfig(config: SiteConfigurationService){
//   return config.load() 
// }


@NgModule({
  declarations: [ AppComponent, HomeComponent, ListComponent, ServicesComponent, NewsComponent, PrivacyComponent, AboutComponent,
                  AdvertisementComponent, ContactComponent, TnsearchpanelComponent, TnhomedescComponent, TnadslistComponent, 
                  TnadslistItemComponent, TnfacebookwidgetComponent, TnsiteheaderComponent, SiteLogo, TnsitefooterComponent, 
                  TnhomesliderComponent, TnhomenewslistComponent, TnnewslistComponent, TnnewslistItemComponent, 
                  TnsearchcodeComponent, TnadslistadvComponent, TempConvertPipe, TnadslistItemComponent, TnadslistadvItemComponent,
                   DetailComponent, NewsdetailComponent, NgbdModalCustomclass, TnGoogleMap, Tnrandomadv ],
  imports:      [ BrowserModule, FormsModule, HttpModule, NgbModule.forRoot(), RouterModule.forRoot(appRoutes) ],
  exports:      [ RouterModule ],
  providers:    [ 
    Meta,
    SiteConfigurationService, 
    { provide: Window, useValue: window },
    { 
      provide:    APP_INITIALIZER, 
      deps:       [SiteConfigurationService], 
      multi:      true,
      useFactory: initConfig //(config: SiteConfigurationService) => () => config.load() //  
    },
   ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/app.module.ts